import React from 'react';

import { cn } from '@change/ds-utils';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { RectangleShapeStyles, SkeletonContainerStyles } from './Header.styles';
import { TextSkeleton1Styles, TextSkeleton2Styles, TextSkeletonContainerStyles } from './HeaderTextSkeletons.styles';
import type { FacebookPostComponentsProps } from './types';

export function Header(props: FacebookPostComponentsProps): React.JSX.Element {
	const { loading, size } = props;

	const rectangleStyles = RectangleShapeStyles({ size });

	return (
		<SkeletonContainer
			loading={loading}
			shapeSize={size}
			className={SkeletonContainerStyles({ size })}
			data-testid="skeleton-container"
		>
			<Circle data-testid="circle" />
			<div className={TextSkeletonContainerStyles({ size })}>
				<Rectangle className={cn(rectangleStyles, TextSkeleton1Styles({ size }))} rounded data-testid="rectangle" />
				<Rectangle className={cn(rectangleStyles, TextSkeleton2Styles({ size }))} rounded data-testid="rectangle" />
			</div>
		</SkeletonContainer>
	);
}
